import AsyncAvFieldSelect from "components/Common/AsyncAvFieldSelect";
import { debounce } from "lodash";
import React, {
  useCallback,
  useEffect,
  useRef,
  useState
} from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default function SearchableComponent(props) {
  const { t } = useTranslation();
  const {
    placeholder = "Search",
    isRequired = false,
    name = "",
    label = "",
    defaultOptions = [],
    value = null,
    onChange = () => { },
    disallowed = null,
    getData = () => { },
    mapper = ( ) => {},
    shouldReset = false,
    raw = false,
  } = props;
  const [selectOptions, setSelectOptions] = useState(defaultOptions);
  const [resetKey, setResetKey] = useState(0);
  const prevValueRef = useRef(value);

  const getDataRef = useRef(getData);
  const mapperRef = useRef(mapper);
  const disallowedRef = useRef(disallowed);
  const rawRef = useRef(raw);

  useEffect(() => {
    getDataRef.current = getData;
    mapperRef.current = mapper;
    disallowedRef.current = disallowed;
    rawRef.current = raw;
  });

  useEffect(() => {
    const prevValue = prevValueRef.current;
    if (prevValue && !value) {
      getDataRef.current({
        page: 1,
        limit: 10000,
      }).then((data) => {
        const mapped = (data || []).map((item) => mapperRef.current(item));
        const filtered = rawRef.current || !disallowedRef.current
          ? mapped
          : mapped.filter((opt) => opt?.value !== disallowedRef.current);
        setSelectOptions(filtered);
        setResetKey((k) => k + 1);
      });
    }
    prevValueRef.current = value;
  }, [value]);

  useEffect(() => {
    const payload = {
      page: 1,
      limit: 10000,
    };
    getData(payload).then((data) => {
      setSelectOptions(data?.
        filter((client) => client._id !== disallowed)
        ?.map(client => mapper(client)));
    });
  }, [shouldReset]);

  const debouncedChangeHandler = useCallback(
    debounce((inputValue, cb) => {
      getData({
        searchText: inputValue,
        page: 1,
        limit: 10000,
      }).then((data) => {
        setSelectOptions(data?.map((client) => mapper(client)));
        return cb(data?.map((client) => mapper(client)));
      });
    }, 1000), []);

  return (
    <AsyncAvFieldSelect
      key={resetKey}
      name={name}
      options={selectOptions}
      label={t(label)}
      errorMessage={t(`${label} is required`)}
      loadOptions={debouncedChangeHandler}
      defaultOptions={selectOptions || defaultOptions}
      value={value || ""}
      defaultValue={value || ""}
      isRequired={isRequired}
      placeholder={placeholder}
      isSearchable={true}
      backspaceRemovesValue={true}
      onChange={onChange}
    />
  );
}
